import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
    changeJob,
    createJob,
    fetchJob,
    editInActive,
} from "../features/job/jobSlice";

const jobTitles = [
    "Software Engineer",
    "Software Developer",
    "Full Stack Developer",
    "MERN Stack Developer",
    "DevOps Engineer",
    "QA Engineer",
    "Product Manager",
    "Social Media Manager",
    "Senior Executive",
    "Junior Executive",
    "Android App Developer",
    "IOS App Developer",
    "Frontend Developer",
    "Frontend Engineer",
];

const jobTypes = [
    "Full Time",
    "Internship",
    "Remote",
];

const inputNameToStateNameMap = {
    lwsJobTitle: 'title',
    lwsJobType: 'type',
    lwsJobSalary: 'salary',
    lwsJobDeadline: 'deadline',
};

export default function Form() {
    //Variable
    const dispatch = useDispatch();
    const { isLoading, isError } = useSelector((state) => state.job);
    const { editing } = useSelector((state) => state.job) || {};
    const navigate = useNavigate();
    const { jobId } = useParams();

    //States
    const [formData, setFormData] = useState({
        title: editing?.title || "",
        type: "",
        salary: "",
        deadline: "",
    });

    //Hooks
    useEffect(() => {
        return () => {
            dispatch(editInActive());
        };
    }, [dispatch])

    useEffect(() => {
        if (jobId) {
            dispatch(fetchJob(jobId))
        } else {
            reset();
        }
    }, [dispatch, jobId]);

    useEffect(() => {
        const { title, type, deadline, salary } = editing || {};
        setFormData({ title, type, salary, deadline });
    }, [editing])


    //Functions
    const reset = () => {
        setFormData({ title: "", type: "", salary: "", deadline: "" });
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const updatedName = inputNameToStateNameMap[name] || name;
        setFormData((prevFormData) => ({ ...prevFormData, [updatedName]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const { title, type, salary, deadline } = formData;
        const jobData = { title, type, salary: Number(salary), deadline };

        if (editing?.id) {
            dispatch(changeJob({ id: editing.id, data: jobData }));
        } else {
            dispatch(createJob(jobData));
        }

        reset();
        navigate("/jobs");
    };

    return (
        <div className="lg:pl-[14rem] mt-[5.8125rem]">
            <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
                <h1 className="mb-10 text-center lws-section-title">{`${editing?.id ? 'Edit Job' : 'Add New Job'}`}</h1>

                <div className="max-w-3xl mx-auto">
                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <div className="fieldContainer">
                            <label htmlFor="lws-JobTitle" className="text-sm font-medium text-slate-300">Job Title</label>
                            <select id="lws-JobTitle" name="lwsJobTitle" required value={formData.title} onChange={handleInputChange}>
                                <option value="" hidden selected>Select Job</option>
                                {jobTitles.map((title) => (
                                    <option key={title} value={title}>{title}</option>
                                ))}
                            </select>
                        </div>

                        <div className="fieldContainer">
                            <label htmlFor="lws-JobType">Job Type</label>
                            <select id="lws-JobType" name="lwsJobType" value={formData.type} onChange={handleInputChange} required>
                                <option value="" hidden selected>Select Job Type</option>
                                {jobTypes.map((type) => (
                                    <option key={type} value={type}>{type}</option>
                                ))}
                            </select>
                        </div>

                        <div className="fieldContainer">
                            <label htmlFor="lws-JobSalary">Salary</label>
                            <div className="flex border rounded-md shadow-sm border-slate-600">
                                <span className="input-tag">BDT</span>
                                <input type="number" name="lwsJobSalary" id="lws-JobSalary" required className="!rounded-l-none !border-0"
                                    placeholder="20,00,000" value={formData.salary} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="fieldContainer">
                            <label htmlFor="lws-JobDeadline">Deadline</label>
                            <input type="date" name="lwsJobDeadline" id="lws-JobDeadline" value={formData.deadline} onChange={handleInputChange} required />
                        </div>

                        <div className="text-right">
                            <button type="submit" id="lws-submit" className="cursor-pointer btn btn-primary w-fit">
                                {editing?.id ? "Update" : "Submit"}
                            </button>
                        </div>
                        {!isLoading && isError && (
                            <p className="error">There was an error occured</p>
                        )}
                    </form>
                </div>
            </main>
        </div>
    );
}
